
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"title":"Edit Geometry","geometryError":"An error occurred while trying to update the geometry.","featureEditor.noLayer":"No Layer","featureEditor.snapping":"Snapping on:"},"de":{"title":"Geometrie Bearbeiten","geometryError":"Beim Aktualisieren der Geometrie ist ein Fehler aufgetreten.","featureEditor.noLayer":"Kein Layer","featureEditor.snapping":"Snapping auf:"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();